import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { useMemo, useEffect, useRef, useState } from 'react';

import Image from 'next/image';
import RequestPartnership from '@/components/RequestPartnership';

import { gaSendEvent } from '@/models/gaEvent';

import { Wrapper } from './styles';

const Navbar: React.FC = () => {
  const router = useRouter();
  const { basePath } = useRouter();
  const { locale, asPath } = router;

  const { t } = useTranslation('common');

  const dropDown = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const [scrolling, setScrolling] = useState(true);
  const [scrollTop, setScrollTop] = useState(0);

  useEffect(() => {
    function onScroll() {
      const currentPosition = window.pageYOffset;
      if (currentPosition > scrollTop) {
        setScrolling(false);
      } else {
        setScrolling(true);
      }
      setScrollTop(currentPosition <= 0 ? 0 : currentPosition);
    }

    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollTop]);

  const onClickActive = () => setIsActive(!isActive);
  useEffect(() => {
    const clickEventPage = (click) => {
      if (
        dropDown.current !== null &&
        !dropDown.current.contains(click.target)
      ) {
        setIsActive(!isActive);
      }
    };

    if (isActive) {
      window.addEventListener('click', clickEventPage);
    }

    return () => {
      window.removeEventListener('click', clickEventPage);
    };
  }, [isActive]);

  const getFlag = useMemo(
    () => ({
      href: `/${locale}`,
      imgSrc: locale === 'en' ? '/usa.png' : '/brazil.png',
      name: locale === 'en' ? 'usa' : 'brazil'
    }),
    [locale]
  );

  const getInvertedFlag = useMemo(
    () => ({
      href: `/${locale === 'en' ? 'br' : 'en'}`,
      imgSrc: locale === 'en' ? '/brazil.png' : '/usa.png',
      name: locale === 'en' ? 'brazil' : 'usa'
    }),
    [locale]
  );

  const toggleTrueFalse = () => setIsActive(!isActive);

  return (
    <>
      <div style={{ display: scrollTop > 0 ? 'none' : 'flex' }}>
        <RequestPartnership />
      </div>
      <Wrapper>
        <div
          className={`navbar ${
            scrolling ? 'navbar_active' : 'navbar_inactive'
          } ${scrollTop > 0 && 'has_shadow'}`}
        >
          <nav>
            <div className="container-nav">
              <div className="cloud">
                <a
                  href={`/${basePath}`}
                  style={{
                    height: '41px',
                    marginTop: '0.3rem'
                  }}
                >
                  <Image
                    priority
                    src="/cloudez.svg"
                    alt="logo"
                    width={222.28}
                    height={54.88}
                  />
                </a>
              </div>

              {asPath.includes('/blog') &&
              asPath.includes('/termos-legais') &&
              asPath.includes('/cadastro-de-parceria') &&
              asPath.includes('/termos-de-servico') &&
              asPath.includes('/privacidade-de-dados') ? (
                <a className="flag-blog">
                  <Image
                    priority
                    src={getFlag.imgSrc}
                    alt={getFlag.name}
                    quality={100}
                    height={30}
                    width={30}
                  />
                </a>
              ) : (
                <a href={getFlag.href} className="flag">
                  <Image
                    priority
                    src={getFlag.imgSrc}
                    alt={getFlag.name}
                    quality={100}
                    height={30}
                    width={30}
                  />
                </a>
              )}

              {!asPath.includes('/blog') &&
                !asPath.includes('/termos-legais') &&
                !asPath.includes('/cadastro-de-parceria') &&
                !asPath.includes('/termos-de-servico') &&
                !asPath.includes('/privacidade-de-dados') &&
                !asPath.includes('/encontre-parceiros-especialistas') && (
                  <>
                    <button
                      className={`arrow ${
                        isActive ? 'button-active' : 'button-inactive'
                      }`}
                      onClick={toggleTrueFalse}
                    >
                      <Image
                        priority
                        src="/arrow.png"
                        alt="arrow"
                        height={6.95}
                        width={12.35}
                        quality={100}
                      />
                    </button>
                    <div
                      ref={dropDown}
                      className={`menu ${isActive ? 'active' : 'inactive'}`}
                    >
                      <a href={getInvertedFlag.href} className="flag">
                        <Image
                          priority
                          src={getInvertedFlag.imgSrc}
                          alt={getInvertedFlag.name}
                          height={30}
                          width={30}
                          quality={100}
                        />
                      </a>
                    </div>
                  </>
                )}

              <div className="links">
                <ul>
                  <li className={!asPath.includes('/blog') ? 'active' : ''}>
                    <a
                      onClick={() => gaSendEvent('Button', 'Home', 'Header')}
                      href={`/${locale || 'br'}`}
                    >
                      Home
                    </a>
                  </li>
                  {locale === 'br' && (
                    <li className={asPath.includes('/blog') ? 'active' : ''}>
                      <a
                        onClick={() => gaSendEvent('Button', 'Blog', 'Header')}
                        href="/br/blog"
                      >
                        Blog
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            </div>

            <div className="buttonsNav">
              <Link href="/br/cadastro-de-parceria">
                <p
                  onClick={() => gaSendEvent('Button', 'Home', 'Header')}
                  className="cadastroNav"
                >
                  {t('hero-1.1.a')}
                </p>
              </Link>

              <a
                onClick={() => gaSendEvent('Button', 'Login', 'Header')}
                className="loginNav"
                target="_blank"
                rel="noreferrer"
                href="https://partners.cloudez.io"
              >
                Login
              </a>
            </div>
          </nav>
        </div>
      </Wrapper>
    </>
  );
};

export default Navbar;
